import dayjs from 'dayjs';
import { FieldType } from '../../../containers/schema-mapper/interfaces/interfaces';

export function getFormattedOutput(rows: any[], headers: any[]) {
  return rows.map((row: any[]) => {
    return row.map((cell: any, index) => {
      return getFormattedValue(cell, headers[index]);
    });
  });
}

export function getFormattedValue(cell: any, headerRef: any) {
  if (typeof cell === 'undefined' || cell === null) {
    return '';
  }

  if (headerRef.jdbc_data_type === 'timestamp') {
    return dayjs(cell).utcOffset(0).format('YYYY-MM-DD HH:mm:ss.SSS');
  }

  if (headerRef.jdbc_data_type === 'timestamptz') {
    return dayjs(cell).utcOffset(0).format('YYYY-MM-DD HH:mm:ss.SSS Z');
  }

  if (headerRef.type === FieldType.STRUCT) {
    cell.json = JSON.stringify(generateStructJson(cell, headerRef), undefined, '\t');
  }

  return cell;
}

export function generateStructJson(cell: any, headerRef: any): any {
  const jsonObject: any = {};

  if (typeof cell === 'undefined' || cell === null) {
    return null;
  }

  for (let index = 0; index < headerRef.fields.length; index++) {
    if (headerRef.fields[index].type === FieldType.OBJECT) {
      jsonObject[headerRef.fields[index].name] = cell[index];
    }

    if (headerRef.fields[index].type === FieldType.ARRAY) {
      jsonObject[headerRef.fields[index].name] = generateArrayJson(
        cell[index],
        headerRef.fields[index]
      );
    }

    if (headerRef.fields[index].type === FieldType.STRUCT) {
      jsonObject[headerRef.fields[index].name] = generateStructJson(
        cell[index],
        headerRef.fields[index]
      );
    }
  }

  return jsonObject;
}

export function generateArrayJson(cell: any, headerRef: any): any {
  if (typeof cell === 'undefined' || cell === null) {
    return null;
  }

  if (!headerRef.fields) {
    return cell;
  } else {
    const newCellValues = [];

    for (let valIndex = 0; valIndex < cell.length; valIndex++) {
      const jsonObject = {};

      for (let fieldIndex = 0; fieldIndex < headerRef.fields.length; fieldIndex++) {
        if (headerRef.fields[fieldIndex].type === FieldType.OBJECT) {
          jsonObject[headerRef.fields[fieldIndex].name] = cell[valIndex][fieldIndex];
        }

        if (headerRef.fields[fieldIndex].type === FieldType.ARRAY) {
          jsonObject[headerRef.fields[fieldIndex].name] = generateArrayJson(
            cell[valIndex][fieldIndex],
            headerRef.fields[fieldIndex]
          );
        }

        if (headerRef.fields[fieldIndex].type === FieldType.STRUCT) {
          jsonObject[headerRef.fields[fieldIndex].name] = generateStructJson(
            cell[valIndex][fieldIndex],
            headerRef.fields[fieldIndex]
          );
        }
      }

      newCellValues[valIndex] = jsonObject;
    }

    return newCellValues;
  }
}
